(function () {
  "use strict";

  var STORAGE_KEY = "nfFloorShortlistV1";

  function readShortlist() {
    try {
      var value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "[]");
      return Array.isArray(value) ? value.filter(function (item) { return item && item.handle; }) : [];
    } catch (error) {
      return [];
    }
  }

  function writeShortlist(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, 12)));
    } catch (error) {}
    window.dispatchEvent(new CustomEvent("nf:shortlist-change", { detail: { items: items.slice(0, 12) } }));
  }

  function itemFromButton(button) {
    return {
      handle: button.dataset.productHandle || "",
      title: button.dataset.productTitle || "",
      url: button.dataset.productUrl || "",
      image: button.dataset.productImage || "",
      price: button.dataset.productPrice || "",
      category: button.dataset.productCategory || "Flooring",
      colour: button.dataset.productColour || "Colour to confirm"
    };
  }

  function designerRead(items) {
    if (items.length < 2) {
      return "Save two floors and the palette consult will describe the mood, undertone relationship and best role for each material.";
    }

    var colours = items.map(function (item) { return String(item.colour || "").toLowerCase(); }).join(" ");
    var categories = items.map(function (item) { return item.category || "Flooring"; }).filter(function (value, index, array) {
      return array.indexOf(value) === index;
    });
    var hasLight = /light|white|ivory|cream|pale|blonde/.test(colours);
    var hasDark = /dark|black|charcoal|espresso|walnut/.test(colours);
    var hasWarm = /oak|natural|warm|honey|tan|brown|blackbutt|spotted gum|beige|terracotta/.test(colours);
    var hasCool = /grey|gray|ash|silver|blue|slate/.test(colours);
    var mood = "tonal and composed";
    var direction = "Repeat one undertone through adjoining rooms, then let texture distinguish each zone.";

    if (hasLight && hasDark) {
      mood = "architectural and high-contrast";
      direction = "Use the lighter floor across the largest area and reserve the darker material for a deliberate room or wet-zone statement, especially where daylight is strongest.";
    } else if (hasWarm && hasCool) {
      mood = "balanced and contemporary";
      direction = "Bridge the warm and cool notes through cabinetry, grout or soft furnishings, and compare both samples beside the same white paint before committing.";
    } else if (hasWarm) {
      mood = "grounded, welcoming and distinctly Australian";
      direction = "Keep the large open area calm, then vary pile, grain or tile finish rather than introducing another competing timber tone.";
    } else if (hasLight) {
      mood = "airy, quiet and visually continuous";
      direction = "Add depth with texture and a mid-tone joinery element so the rooms feel layered rather than washed out.";
    } else if (hasDark) {
      mood = "intimate, tailored and luxurious";
      direction = "Protect contrast with pale walls and good daylight, and use the darkest finish where the room has enough visual breathing space.";
    } else if (hasCool) {
      mood = "calm, crisp and modern";
      direction = "Warm the palette with timber furniture, natural fabric or warmer lighting before repeating cool grey across every room.";
    }

    return "Designer read: this " + categories.join(" + ").toLowerCase() + " combination feels " + mood + ". " + direction + " Confirm the relationship with physical samples under your own daylight or together in a showroom.";
  }

  function appendShortlistItem(container, item, onRemove) {
    var row = document.createElement("div");
    row.className = "nf-cat__shortlist-item";

    if (item.image) {
      var image = document.createElement("img");
      image.src = item.image;
      image.alt = "";
      image.loading = "lazy";
      row.appendChild(image);
    } else {
      row.appendChild(document.createElement("span"));
    }

    var copy = document.createElement("div");
    var link = document.createElement("a");
    link.href = item.url || "#";
    link.textContent = item.title || "Saved floor";
    copy.appendChild(link);
    var meta = document.createElement("small");
    meta.textContent = [item.category, item.colour, item.price].filter(Boolean).join(" / ");
    copy.appendChild(meta);
    row.appendChild(copy);

    var remove = document.createElement("button");
    remove.className = "nf-cat__shortlist-remove";
    remove.type = "button";
    remove.textContent = "\u00d7";
    remove.setAttribute("aria-label", "Remove " + (item.title || "floor") + " from shortlist");
    remove.addEventListener("click", function () { onRemove(item.handle, remove); });
    row.appendChild(remove);
    container.appendChild(row);
  }

  function initResponsiveShell(root) {
    if (!root || root.dataset.nfResponsiveShellReady === "true") return;
    root.dataset.nfResponsiveShellReady = "true";

    var nav = root.querySelector(".nf-cat__nav");
    var currentCategory = nav && nav.querySelector('[aria-current="page"]');
    var shop = root.querySelector("#shop");
    var filters = root.querySelector("[data-nf-filters]");
    var frame = 0;
    var navSnapFrame = 0;
    var navInlineSnap = nav ? nav.style.scrollSnapType : "";

    function mobileFiltersOpen() {
      return filters && filters.classList.contains("is-open") && window.matchMedia("(max-width: 979px)").matches;
    }

    function filterFocusableItems() {
      if (!filters) return [];
      return Array.prototype.slice.call(filters.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])')).filter(function (item) {
        return item.offsetParent !== null;
      });
    }

    function focusFilterStart() {
      if (!mobileFiltersOpen()) return;
      var focusable = filterFocusableItems();
      var target = filters.querySelector("[data-nf-filter-close]") || focusable[0] || filters;
      filters.style.setProperty("transition-property", "transform", "important");
      filters.style.setProperty("visibility", "visible", "important");
      filters.getBoundingClientRect();
      if (!filters.contains(document.activeElement)) target.focus({ preventScroll: true });
      window.requestAnimationFrame(function () {
        filters.style.removeProperty("transition-property");
        filters.style.removeProperty("visibility");
      });
    }

    function syncShellGeometry() {
      frame = 0;
      if (!nav) return;
      var stickyTop = parseFloat(window.getComputedStyle(nav).top);
      if (!Number.isFinite(stickyTop)) stickyTop = 0;
      var stickyOffset = Math.ceil(Math.max(0, stickyTop) + nav.getBoundingClientRect().height + 12);
      root.style.setProperty("--nf-cu-sticky-offset", stickyOffset + "px");
    }

    function revealCurrentCategory() {
      if (!nav || !currentCategory || nav.scrollWidth <= nav.clientWidth + 1) return;
      var navRect = nav.getBoundingClientRect();
      var currentRect = currentCategory.getBoundingClientRect();
      var target = nav.scrollLeft + currentRect.left - navRect.left - (nav.clientWidth - currentRect.width) / 2;
      var maximum = Math.max(0, nav.scrollWidth - nav.clientWidth);
      var clampedTarget = Math.max(0, Math.min(maximum, target));
      if (navSnapFrame) window.cancelAnimationFrame(navSnapFrame);
      nav.style.scrollSnapType = "none";
      nav.scrollLeft = clampedTarget;
      navSnapFrame = window.requestAnimationFrame(function () {
        navSnapFrame = 0;
        nav.style.scrollSnapType = navInlineSnap;
      });
    }

    function alignShop() {
      if (!shop || window.location.hash !== "#shop") return;
      var offset = parseFloat(window.getComputedStyle(root).getPropertyValue("--nf-cu-sticky-offset")) || 136;
      var top = shop.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: "auto" });
    }

    function scheduleSync(includeShop) {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        syncShellGeometry();
        revealCurrentCategory();
        if (includeShop) alignShop();
      });
    }

    root.addEventListener("click", function (event) {
      var filterToggle = event.target.closest("[data-nf-filter-toggle]");
      if (filterToggle && root.contains(filterToggle)) {
        focusFilterStart();
        if (typeof window.queueMicrotask === "function") window.queueMicrotask(focusFilterStart);
        else Promise.resolve().then(focusFilterStart);
      }

      var link = event.target.closest('a[href="#shop"]');
      if (!link || !root.contains(link)) return;
      window.requestAnimationFrame(function () { scheduleSync(true); });
    });

    document.addEventListener("keydown", function (event) {
      if (!mobileFiltersOpen() || event.key !== "Tab") return;
      var focusable = filterFocusableItems();
      if (!focusable.length) {
        event.preventDefault();
        filters.focus({ preventScroll: true });
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (!filters.contains(document.activeElement)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus({ preventScroll: true });
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus({ preventScroll: true });
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      }
    }, true);

    document.addEventListener("focusin", function (event) {
      if (!mobileFiltersOpen() || filters.contains(event.target)) return;
      focusFilterStart();
    }, true);

    window.addEventListener("hashchange", function () { scheduleSync(true); });
    window.addEventListener("resize", function () { scheduleSync(false); }, { passive: true });
    window.addEventListener("load", function () { scheduleSync(window.location.hash === "#shop"); }, { once: true });
    window.addEventListener("pageshow", function () { scheduleSync(window.location.hash === "#shop"); });

    syncShellGeometry();
    revealCurrentCategory();
    scheduleSync(window.location.hash === "#shop");
    window.requestAnimationFrame(function () { scheduleSync(window.location.hash === "#shop"); });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { scheduleSync(window.location.hash === "#shop"); });
    }
  }

  function init(root) {
    if (!root) return;
    initResponsiveShell(root);
    if (root.dataset.nfCategoryUniverseReady === "true") return;
    root.dataset.nfCategoryUniverseReady = "true";

    var drawer = root.querySelector("[data-nf-cat-shortlist]");
    var scrim = root.querySelector("[data-nf-cat-shortlist-scrim]");
    var openers = Array.prototype.slice.call(root.querySelectorAll("[data-nf-cat-shortlist-open]"));
    var closeButton = root.querySelector("[data-nf-cat-shortlist-close]");
    var itemsNode = root.querySelector("[data-nf-cat-shortlist-items]");
    var countNodes = Array.prototype.slice.call(root.querySelectorAll("[data-nf-cat-shortlist-count]"));
    var consultNode = root.querySelector("[data-nf-cat-shortlist-consult]");
    var activeOpener = null;

    function syncOverlayInsets() {
      var previewToolbar = document.querySelector(".vtl-ql-main-widget");
      var toolbarHeight = 0;
      if (previewToolbar && window.getComputedStyle(previewToolbar).position === "fixed") {
        var toolbarRect = previewToolbar.getBoundingClientRect();
        if (toolbarRect.bottom > 0 && toolbarRect.height > 0) toolbarHeight = Math.ceil(toolbarRect.height);
      }
      document.body.style.setProperty("--nf-preview-toolbar-height", toolbarHeight + "px");
    }

    // Keep the modal surface outside theme header and section stacking contexts.
    document.body.querySelectorAll("[data-nf-cat-shortlist-portal]").forEach(function (node) {
      if (node !== drawer && node !== scrim) node.remove();
    });
    if (scrim) {
      scrim.dataset.nfCatShortlistPortal = "true";
      document.body.appendChild(scrim);
    }
    if (drawer) {
      drawer.dataset.nfCatShortlistPortal = "true";
      document.body.appendChild(drawer);
    }

    function removeItem(handle, trigger) {
      var removeButtons = itemsNode ? Array.prototype.slice.call(itemsNode.querySelectorAll(".nf-cat__shortlist-remove")) : [];
      var removalIndex = trigger ? removeButtons.indexOf(trigger) : -1;
      writeShortlist(readShortlist().filter(function (item) { return item.handle !== handle; }));
      paint();
      if (drawer && drawer.classList.contains("is-open") && removalIndex >= 0) {
        var remaining = itemsNode ? Array.prototype.slice.call(itemsNode.querySelectorAll(".nf-cat__shortlist-remove")) : [];
        var next = remaining[removalIndex] || remaining[removalIndex - 1];
        var consultAction = drawer.querySelector(".nf-cat__shortlist-consult a, .nf-cat__shortlist-consult button");
        (next || closeButton || consultAction || drawer).focus({ preventScroll: true });
      }
    }

    function paint() {
      var items = readShortlist();
      countNodes.forEach(function (node) { node.textContent = String(items.length); });
      root.querySelectorAll("[data-nf-shortlist-add]").forEach(function (button) {
        var saved = items.some(function (item) { return item.handle === button.dataset.productHandle; });
        button.classList.toggle("is-saved", saved);
        button.setAttribute("aria-pressed", saved ? "true" : "false");
        button.setAttribute("aria-label", (saved ? "Remove " : "Save ") + (button.dataset.shortlistAccessibleLabel || button.dataset.productTitle || "floor") + (saved ? " from shortlist" : " to shortlist"));
        button.title = saved ? "Remove from shortlist" : "Save to shortlist";
      });

      if (itemsNode) {
        itemsNode.replaceChildren();
        if (!items.length) {
          var empty = document.createElement("p");
          empty.className = "nf-cat__shortlist-empty";
          empty.textContent = "No floors saved yet. Use the heart on any product to build a whole-home comparison.";
          itemsNode.appendChild(empty);
        } else {
          items.forEach(function (item) { appendShortlistItem(itemsNode, item, removeItem); });
        }
      }
      if (consultNode) consultNode.textContent = designerRead(items);
    }

    function focusableItems() {
      if (!drawer) return [];
      return Array.prototype.slice.call(drawer.querySelectorAll("a[href], button:not([disabled]), [tabindex]:not([tabindex='-1'])")).filter(function (item) {
        return item.offsetParent !== null;
      });
    }

    function setDrawer(open, opener) {
      if (!drawer || !scrim) return;
      if (open) {
        syncOverlayInsets();
        activeOpener = opener || document.activeElement;
        drawer.hidden = false;
        scrim.hidden = false;
        paint();
        drawer.setAttribute("aria-hidden", "false");
        root.classList.add("is-shortlist-open");
        document.body.classList.add("nf-cat-shortlist-lock");
        openers.forEach(function (button) { button.setAttribute("aria-expanded", "true"); });
        drawer.style.setProperty("transition-property", "transform", "important");
        drawer.style.setProperty("visibility", "visible", "important");
        drawer.getBoundingClientRect();
        (closeButton || drawer).focus({ preventScroll: true });
        drawer.classList.add("is-open");
        scrim.classList.add("is-open");
        window.requestAnimationFrame(function () {
          drawer.style.removeProperty("transition-property");
          drawer.style.removeProperty("visibility");
        });
      } else {
        drawer.classList.remove("is-open");
        scrim.classList.remove("is-open");
        drawer.setAttribute("aria-hidden", "true");
        root.classList.remove("is-shortlist-open");
        document.body.classList.remove("nf-cat-shortlist-lock");
        openers.forEach(function (button) { button.setAttribute("aria-expanded", "false"); });
        window.setTimeout(function () {
          if (!drawer.classList.contains("is-open")) {
            drawer.hidden = true;
            scrim.hidden = true;
          }
        }, 300);
        if (activeOpener && typeof activeOpener.focus === "function") {
          window.setTimeout(function () { activeOpener.focus({ preventScroll: true }); }, 20);
        }
      }
    }

    openers.forEach(function (button) {
      button.addEventListener("click", function () { setDrawer(true, button); });
    });
    if (closeButton) closeButton.addEventListener("click", function () { setDrawer(false); });
    if (scrim) scrim.addEventListener("click", function () { setDrawer(false); });

    document.addEventListener("shopify:section:unload", function (event) {
      if (!event.target || !event.target.contains(root)) return;
      if (drawer) drawer.remove();
      if (scrim) scrim.remove();
      document.body.classList.remove("nf-cat-shortlist-lock");
    });

    root.addEventListener("click", function (event) {
      var button = event.target.closest("[data-nf-shortlist-add]");
      if (!button || !root.contains(button)) return;
      event.preventDefault();
      var item = itemFromButton(button);
      if (!item.handle) return;
      var items = readShortlist();
      var saved = items.some(function (entry) { return entry.handle === item.handle; });
      if (saved) items = items.filter(function (entry) { return entry.handle !== item.handle; });
      else items.unshift(item);
      writeShortlist(items);
      paint();
    });

    document.addEventListener("keydown", function (event) {
      if (!drawer || !drawer.classList.contains("is-open")) return;
      if (event.key === "Escape") {
        event.preventDefault();
        setDrawer(false);
        return;
      }
      if (event.key !== "Tab") return;
      var focusable = focusableItems();
      if (!focusable.length) {
        event.preventDefault();
        drawer.focus({ preventScroll: true });
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (!drawer.contains(document.activeElement)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus({ preventScroll: true });
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus({ preventScroll: true });
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      }
    }, true);

    document.addEventListener("focusin", function (event) {
      if (!drawer || !drawer.classList.contains("is-open") || drawer.contains(event.target)) return;
      (closeButton || focusableItems()[0] || drawer).focus({ preventScroll: true });
    }, true);

    window.addEventListener("storage", function (event) {
      if (event.key === STORAGE_KEY) paint();
    });
    window.addEventListener("nf:shortlist-change", paint);

    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!reducedMotion && "IntersectionObserver" in window) {
      root.classList.add("nf-cu-animate");
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      }, { rootMargin: "0px 0px -8%", threshold: 0.08 });
      root.querySelectorAll(".nf-cat-card, .nf-cat__path").forEach(function (item) { observer.observe(item); });
    }

    paint();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-nf-cat]").forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  else initAll(document);

  document.addEventListener("shopify:section:load", function (event) { initAll(event.target); });
})();
